import { wire, definition, context, component } from "@uesio/ui"

export type ListDeckOptions = {
  components: definition.DefinitionList
}

interface ListFieldDeckUtilityProps {
  mode: context.FieldMode
  value: wire.FieldValue
  path: string
  options?: ListDeckOptions
  readonly?: boolean
}

const ListFieldDeck: definition.UtilityComponent<ListFieldDeckUtilityProps> = (
  props,
) => {
  const value = props.value as wire.PlainWireRecord[]
  const readonly = props.readonly || props.mode === "READ"
  const childContext = readonly
    ? props.context.addFieldModeFrame("READ")
    : props.context
  return value?.map((record, index) => (
    <component.Slot
      key={index}
      definition={props.options}
      listName="components"
      path={props.path}
      context={childContext.addRecordDataFrame(record, index)}
      readonly={readonly}
    />
  ))
}

export default ListFieldDeck
